import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'react-input-range/lib/css/index.css';

import storage from './services/storage';
import Main from './bin/Main';
import './style.css';


const App = () => (
  <Provider store={storage}>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
    <ToastContainer />
  </Provider>
)

export default App

